export const HorizontalVector = ({ className = '' }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="15"
      height="6"
      viewBox="0 0 15 6"
      fill="none"
      className={className}
    >
      <path
        xmlns="http://www.w3.org/2000/svg"
        d="M2.68183 5.48823H12.1844C13.6659 5.48823 14.8662 4.37454 14.8662 3.00009C14.8662 1.62565 13.6659 0.511963 12.1844 0.511963H2.68183C1.20035 0.511963 0 1.62565 0 3.00009C0 4.37454 1.20035 5.48823 2.68183 5.48823Z"
        fill="#05F273"
      />
    </svg>
  );
};
